(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[7],{

/***/ "3sMf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ createIcon; });

// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/esm/forward-ref.js
var forward_ref = __webpack_require__("sKyC");

// CONCATENATED MODULE: ./node_modules/@chakra-ui/icons/node_modules/@chakra-ui/utils/dist/esm/assertion.js
// Number assertions
function isNumber(value) {
  return typeof value === "number";
}
var isNotNumber = value => typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
function isNumeric(value) {
  return value != null && value - parseFloat(value) + 1 >= 0;
} // Array assertions

function isArray(value) {
  return Array.isArray(value);
}
var isEmptyArray = value => isArray(value) && value.length === 0; // Function assertions

function isFunction(value) {
  return typeof value === "function";
} // Generic assertions

var isDefined = value => typeof value !== "undefined" && value !== undefined;
var isUndefined = value => typeof value === "undefined" || value === undefined; // Object assertions

var isObject = value => {
  var type = typeof value;
  return value != null && (type === "object" || type === "function") && !isArray(value);
};
var isEmptyObject = value => isObject(value) && Object.keys(value).length === 0;
function isNotEmptyObject(value) {
  return value && !isEmptyObject(value);
}
var isNull = value => value == null; // String assertions

function isString(value) {
  return Object.prototype.toString.call(value) === "[object String]";
} // Event assertions

function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
} // Empty assertions

var isEmpty = value => {
  if (isArray(value)) return isEmptyArray(value);
  if (isObject(value)) return isEmptyObject(value);
  if (value == null || value === "") return true;
  return false;
}; // eslint-disable-next-line @typescript-eslint/naming-convention

var __DEV__ = "production" !== "production";
//# sourceMappingURL=assertion.js.map
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/esm/system.js + 4 modules
var system = __webpack_require__("U6LL");

// CONCATENATED MODULE: ./node_modules/@chakra-ui/icons/node_modules/@chakra-ui/utils/dist/esm/dom.js
var win;
/**
 * Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
 * hits a memory leak, whereas aliasing it and calling "typeof win" does not.
 * Caching the window value at the file scope lets us minimize the impact.
 *
 * @see IE11 Memory Leak Issue https://github.com/microsoft/fluentui/pull/9010#issuecomment-490768427
 */

try {
  win = window;
} catch (e) {
  /* no-op */
}
/**
 * Helper to get the window object. The helper will make sure to use a cached variable
 * of "window", to avoid overhead and memory leaks in IE11.
 */


var getWindow = node => {
  var _node$ownerDocument$d, _node$ownerDocument;

  return (_node$ownerDocument$d = node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) != null ? _node$ownerDocument$d : win;
};
/**
 * Check if we can use the DOM. Useful for SSR purposes
 */

function checkIsBrowser() {
  var win = getWindow();
  return Boolean(typeof win !== "undefined" && win.document && win.document.createElement);
}

var isBrowser = checkIsBrowser();
/**
 * Get the normalized event key across all browsers
 * @param event keyboard event
 */

function normalizeEventKey(event) {
  var {
    key,
    keyCode
  } = event;
  var isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
  var eventKey = isArrowKey ? "Arrow" + key : key;
  return eventKey;
}
var dataAttr = condition => condition ? "" : undefined;
var ariaAttr = condition => condition ? true : undefined;
var getDocument = node => node != null && node.ownerDocument || isBrowser ? document : null;
var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(Boolean).join(" ");
};
function getActiveElement(node) {
  var doc = getDocument(node);
  return doc == null ? void 0 : doc.activeElement;
}
function contains(parent, child) {
  return parent === child || parent.contains(child);
}
//# sourceMappingURL=dom.js.map
// CONCATENATED MODULE: ./node_modules/@chakra-ui/icons/node_modules/@chakra-ui/icon/dist/esm/icon.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var fallbackIcon = {
  path: /*#__PURE__*/react["createElement"]("g", {
    stroke: "currentColor",
    strokeWidth: "1.5"
  }, /*#__PURE__*/react["createElement"]("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
  }), /*#__PURE__*/react["createElement"]("path", {
    fill: "currentColor",
    strokeLinecap: "round",
    d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
  }), /*#__PURE__*/react["createElement"]("circle", {
    fill: "none",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "12",
    r: "11.25"
  })),
  viewBox: "0 0 24 24"
};
var Icon = /*#__PURE__*/Object(forward_ref["a" /* forwardRef */])((props, ref) => {
  var {
    as: element,
    viewBox,
    color = "currentColor",
    focusable = false,
    children,
    className,
    __css
  } = props,
      rest = _objectWithoutPropertiesLoose(props, ["as", "viewBox", "color", "focusable", "children", "className", "__css"]);

  var _className = cx("chakra-icon", className);

  var styles = _extends({
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color
  }, __css);

  var shared = {
    ref,
    focusable,
    className: _className,
    __css: styles
  };

  var _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;
  /**
   * If you're using an icon library like `react-icons`.
   * Note: anyone passing the `as` prop, should manage the `viewBox` from the external component
   */


  if (element && typeof element !== "string") {
    return /*#__PURE__*/react["createElement"](system["a" /* chakra */].svg, _extends({
      as: element
    }, shared, rest));
  }

  var _path = children != null ? children : fallbackIcon.path;

  return /*#__PURE__*/react["createElement"](system["a" /* chakra */].svg, _extends({
    verticalAlign: "middle",
    viewBox: _viewBox
  }, shared, rest), _path);
});

if (__DEV__) {
  Icon.displayName = "Icon";
}

/* harmony default export */ var icon = (Icon);
//# sourceMappingURL=icon.js.map
// CONCATENATED MODULE: ./node_modules/@chakra-ui/icons/node_modules/@chakra-ui/icon/dist/esm/create-icon.js
function create_icon_extends() { create_icon_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return create_icon_extends.apply(this, arguments); }





function createIcon(options) {
  var {
    viewBox = "0 0 24 24",
    d: pathDefinition,
    path,
    displayName,
    defaultProps = {}
  } = options;
  var Comp = /*#__PURE__*/Object(forward_ref["a" /* forwardRef */])((props, ref) => /*#__PURE__*/react["createElement"](Icon, create_icon_extends({
    ref: ref,
    viewBox: viewBox
  }, defaultProps, props), path != null ? path : /*#__PURE__*/react["createElement"]("path", {
    fill: "currentColor",
    d: pathDefinition
  })));

  if (__DEV__) {
    Comp.displayName = displayName;
  }

  return Comp;
}
//# sourceMappingURL=create-icon.js.map

/***/ }),

/***/ "4jWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ useStyleConfig; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ useMultiStyleConfig; });

// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/esm/object.js
var object = __webpack_require__("BXwj");

// EXTERNAL MODULE: ./node_modules/lodash.mergewith/index.js
var lodash_mergewith = __webpack_require__("qd8s");
var lodash_mergewith_default = /*#__PURE__*/__webpack_require__.n(lodash_mergewith);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/esm/function.js
var esm_function = __webpack_require__("KwD7");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__("bmMU");
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/esm/color-mode-provider.js + 2 modules
var color_mode_provider = __webpack_require__("+p43");

// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/esm/providers.js
var providers = __webpack_require__("5+Am");

// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/esm/system.utils.js
var system_utils = __webpack_require__("CRla");

// CONCATENATED MODULE: ./node_modules/@chakra-ui/system/dist/esm/hooks.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }







function useChakra() {
  var colorModeResult = Object(color_mode_provider["b" /* useColorMode */])();
  var theme = Object(providers["d" /* useTheme */])();
  return _extends({}, colorModeResult, {
    theme
  });
}
function useToken(scale, token, fallback) {
  var theme = Object(providers["d" /* useTheme */])();

  if (Array.isArray(token)) {
    var fallbackArr = [];

    if (fallback) {
      fallbackArr = Array.isArray(fallback) ? fallback : [fallback];
    }

    return token.map((token, index) => {
      var _fallbackArr$index;

      var path = scale + "." + token;
      return Object(object["c" /* memoizedGet */])(theme, path, (_fallbackArr$index = fallbackArr[index]) != null ? _fallbackArr$index : token);
    });
  }

  var path = scale + "." + token;
  return Object(object["c" /* memoizedGet */])(theme, path, fallback != null ? fallback : token);
}
function useProps(themeKey, props) {
  var _theme$components, _styleConfig$defaultP;

  var {
    theme,
    colorMode
  } = useChakra();
  var styleConfig = props.styleConfig || ((_theme$components = theme.components) == null ? void 0 : _theme$components[themeKey]);
  var defaultProps = (_styleConfig$defaultP = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _styleConfig$defaultP : {};

  var propsWithDefault = _extends({}, defaultProps, Object(object["a" /* filterUndefined */])(props));

  var stylesRef = Object(react["useRef"])({});
  var mergedProps = lodash_mergewith_default()({}, propsWithDefault, {
    theme,
    colorMode
  });
  var memoizedStyles = Object(react["useMemo"])(() => {
    if (styleConfig) {
      var _styleConfig$baseStyl, _styleConfig$variants, _styleConfig$variants2, _styleConfig$sizes, _styleConfig$sizes2;

      var baseStyles = Object(esm_function["c" /* runIfFn */])((_styleConfig$baseStyl = styleConfig.baseStyle) != null ? _styleConfig$baseStyl : {}, mergedProps);
      var variants = Object(esm_function["c" /* runIfFn */])((_styleConfig$variants = (_styleConfig$variants2 = styleConfig.variants) == null ? void 0 : _styleConfig$variants2[mergedProps.variant]) != null ? _styleConfig$variants : {}, mergedProps);
      var sizes = Object(esm_function["c" /* runIfFn */])((_styleConfig$sizes = (_styleConfig$sizes2 = styleConfig.sizes) == null ? void 0 : _styleConfig$sizes2[mergedProps.size]) != null ? _styleConfig$sizes : {}, mergedProps);
      var styles = lodash_mergewith_default()(baseStyles, sizes, variants);

      if (styleConfig.parts) {
        styleConfig.parts.forEach(part => {
          var _styles$part;

          styles[part] = (_styles$part = styles[part]) != null ? _styles$part : {};
        });
      }

      var isStyleEqual = react_fast_compare_default()(stylesRef.current, styles);

      if (!isStyleEqual) {
        stylesRef.current = styles;
      }
    }

    return stylesRef.current;
  }, [styleConfig, mergedProps]);
  return {
    styles: memoizedStyles,
    props: Object(system_utils["b" /* omitThemingProps */])(propsWithDefault)
  };
}
//# sourceMappingURL=hooks.js.map
// CONCATENATED MODULE: ./node_modules/@chakra-ui/system/dist/esm/use-style-config.js
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





function useStyleConfig(themeKey, props, opts) {
  var _styleConfig$defaultP, _opts2;

  if (props === void 0) {
    props = {};
  }

  if (opts === void 0) {
    opts = {};
  }

  var {
    styleConfig: styleConfigProp
  } = props,
      rest = _objectWithoutPropertiesLoose(props, ["styleConfig"]);

  var {
    theme,
    colorMode
  } = useChakra();
  var themeStyleConfig = Object(object["c" /* memoizedGet */])(theme, "components." + themeKey);
  var styleConfig = styleConfigProp || themeStyleConfig;
  var mergedProps = lodash_mergewith_default()({
    theme,
    colorMode
  }, (_styleConfig$defaultP = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _styleConfig$defaultP : {}, Object(object["a" /* filterUndefined */])(Object(object["f" /* omit */])(rest, ["children"])));
  /**
   * Store the computed styles in a `ref` to avoid unneeded re-computation
   */

  var stylesRef = Object(react["useRef"])({});
  return Object(react["useMemo"])(() => {
    if (styleConfig) {
      var _styleConfig$baseStyl, _styleConfig$variants, _styleConfig$variants2, _styleConfig$sizes$me, _styleConfig$sizes, _opts;

      var baseStyles = Object(esm_function["c" /* runIfFn */])((_styleConfig$baseStyl = styleConfig.baseStyle) != null ? _styleConfig$baseStyl : {}, mergedProps);
      var variants = Object(esm_function["c" /* runIfFn */])((_styleConfig$variants = (_styleConfig$variants2 = styleConfig.variants) == null ? void 0 : _styleConfig$variants2[mergedProps.variant]) != null ? _styleConfig$variants : {}, mergedProps);
      var sizes = Object(esm_function["c" /* runIfFn */])((_styleConfig$sizes$me = (_styleConfig$sizes = styleConfig.sizes) == null ? void 0 : _styleConfig$sizes[mergedProps.size]) != null ? _styleConfig$sizes$me : {}, mergedProps);
      var styles = lodash_mergewith_default()({}, baseStyles, sizes, variants);

      if ((_opts = opts) != null && _opts.isMultiPart && styleConfig.parts) {
        styleConfig.parts.forEach(part => {
          var _styles$part;

          styles[part] = (_styles$part = styles[part]) != null ? _styles$part : {};
        });
      }

      var isStyleEqual = react_fast_compare_default()(stylesRef.current, styles);

      if (!isStyleEqual) {
        stylesRef.current = styles;
      }
    }

    return stylesRef.current;
  }, [styleConfig, mergedProps, (_opts2 = opts) == null ? void 0 : _opts2.isMultiPart]);
}
function useMultiStyleConfig(themeKey, props) {
  return useStyleConfig(themeKey, props, {
    isMultiPart: true
  });
}
//# sourceMappingURL=use-style-config.js.map

/***/ }),

/***/ "bmMU":
/***/ (function(module, exports) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ "wZsY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ stack_Stack; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ HStack; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ VStack; });

// UNUSED EXPORTS: StackDivider, StackItem

// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/esm/system.js + 4 modules
var system = __webpack_require__("U6LL");

// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/esm/forward-ref.js
var forward_ref = __webpack_require__("sKyC");

// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/esm/react-helpers.js
var react_helpers = __webpack_require__("JX03");

// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/esm/dom.js
var dom = __webpack_require__("epLR");

// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/esm/assertion.js
var assertion = __webpack_require__("pr4h");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/esm/responsive.js
var responsive = __webpack_require__("x9W9");

// CONCATENATED MODULE: ./node_modules/@chakra-ui/layout/dist/esm/stack.utils.js


/**
 * If we ever run into SSR issues with this, check this post to find a fix for it:
 * @see https://medium.com/@emmenko/patching-lobotomized-owl-selector-for-emotion-ssr-5a582a3c424c
 */
var selector = "& > *:not(style) ~ *:not(style)";
function getStackStyles(options) {
  var {
    spacing,
    direction
  } = options;
  var directionStyles = {
    column: {
      mt: spacing,
      ml: 0
    },
    row: {
      ml: spacing,
      mt: 0
    },
    "column-reverse": {
      mb: spacing,
      mr: 0
    },
    "row-reverse": {
      mr: spacing,
      mb: 0
    }
  };
  return {
    flexDirection: direction,
    [selector]: Object(responsive["b" /* mapResponsive */])(direction, value => directionStyles[value])
  };
}
function getDividerStyles(options) {
  var {
    spacing,
    direction
  } = options;
  var dividerStyles = {
    column: {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": Object(responsive["b" /* mapResponsive */])(direction, value => dividerStyles[value])
  };
}
//# sourceMappingURL=stack.utils.js.map
// CONCATENATED MODULE: ./node_modules/@chakra-ui/layout/dist/esm/stack.js
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }





var StackDivider = props => {
  return /*#__PURE__*/react["createElement"](system["a" /* chakra */].div, _extends({
    className: "chakra-stack__divider"
  }, props, {
    __css: _extends({}, props["__css"], {
      borderWidth: 0,
      alignSelf: "stretch",
      borderColor: "inherit",
      width: "auto",
      height: "auto"
    })
  }));
};
var StackItem = props => /*#__PURE__*/react["createElement"](system["a" /* chakra */].div, _extends({
  className: "chakra-stack__item"
}, props, {
  __css: _extends({
    display: "inline-block",
    flex: "0 0 auto",
    minWidth: 0
  }, props["__css"])
}));

/**
 * Stacks help you easily create flexible and automatically distributed layouts
 *
 * You can stack elements in the horizontal or vertical direction,
 * and apply a space or/and divider between each element.
 *
 * It uses `display: flex` internally and renders a `div`.
 *
 * @see Docs https://chakra-ui.com/components/stack
 *
 */
var stack_Stack = /*#__PURE__*/Object(forward_ref["a" /* forwardRef */])(function Stack(props, ref) {
  var {
    isInline,
    direction: directionProp,
    align,
    justify,
    spacing = "0.5rem",
    wrap,
    children,
    divider,
    className,
    shouldWrapChildren
  } = props,
      rest = _objectWithoutPropertiesLoose(props, ["isInline", "direction", "align", "justify", "spacing", "wrap", "children", "divider", "className", "shouldWrapChildren"]);

  var direction = isInline ? "row" : directionProp != null ? directionProp : "column";
  var styles = react["useMemo"](() => getStackStyles({
    direction,
    spacing
  }), [direction, spacing]);
  var dividerStyle = react["useMemo"](() => getDividerStyles({
    spacing,
    direction
  }), [spacing, direction]);
  var hasDivider = !!divider;
  var shouldUseChildren = !shouldWrapChildren && !hasDivider;
  var validChildren = Object(react_helpers["b" /* getValidChildren */])(children);
  var clones = shouldUseChildren ? validChildren : validChildren.map((child, index) => {
    var isLast = index + 1 === validChildren.length;
    var wrappedChild = /*#__PURE__*/react["createElement"](StackItem, {
      key: index
    }, child);

    var _child = shouldWrapChildren ? wrappedChild : child;

    if (!hasDivider) return _child;
    var clonedDivider = /*#__PURE__*/react["cloneElement"](divider, {
      __css: dividerStyle
    });

    var _divider = isLast ? null : clonedDivider;

    return /*#__PURE__*/react["createElement"](react["Fragment"], {
      key: index
    }, _child, _divider);
  });

  var _className = Object(dom["c" /* cx */])("chakra-stack", className);

  return /*#__PURE__*/react["createElement"](system["a" /* chakra */].div, _extends({
    ref: ref,
    display: "flex",
    alignItems: align,
    justifyContent: justify,
    flexDirection: styles.flexDirection,
    flexWrap: wrap,
    className: _className,
    __css: hasDivider ? {} : {
      [selector]: styles[selector]
    }
  }, rest), clones);
});

if (assertion["a" /* __DEV__ */]) {
  stack_Stack.displayName = "Stack";
}
/**
 * A view that arranges its children in a horizontal line.
 */


var HStack = /*#__PURE__*/Object(forward_ref["a" /* forwardRef */])((props, ref) => {
  return /*#__PURE__*/react["createElement"](stack_Stack, _extends({
    align: "center"
  }, props, {
    direction: "row",
    ref: ref
  }));
});

if (assertion["a" /* __DEV__ */]) {
  HStack.displayName = "HStack";
}
/**
 * A view that arranges its children in a vertical line.
 */


var VStack = /*#__PURE__*/Object(forward_ref["a" /* forwardRef */])((props, ref) => {
  return /*#__PURE__*/react["createElement"](stack_Stack, _extends({
    align: "center"
  }, props, {
    direction: "column",
    ref: ref
  }));
});

if (assertion["a" /* __DEV__ */]) {
  VStack.displayName = "VStack";
}
//# sourceMappingURL=stack.js.map

/***/ })

}]);